// extracted by mini-css-extract-plugin
module.exports = {"button":"pop-up-text-error_button__8bA1e","footer":"pop-up-text-error_footer__khGjh","content":"pop-up-text-error_content__OgR6X","dialog":"pop-up-text-error_dialog__D2_nf"};